<template>
  <div
    class="sponsor-box pos-relative h-100 px-300 py-600 text-align-center flex-center"
  >
    <div class="sponsor-box__inner pos-relative">
      <div v-if="sponsor_title" class="sponsor-box__logo mb-600">
        <a :href="sponsor_link" :aria-label="sponsor_title" target="_blank">
          <img v-if="!logo" :src="logo" :alt="sponsor_title" width="400" />
          <img
            v-else
            src="@/assets/FanExam_Horiz_3x_Blk_powered.png"
            :alt="sponsor_title"
          />
        </a>
      </div>
      <div class="sponsor-box__text" v-html="text"></div>
      <div v-if="showAvatar" class="avatar">
        <img src="@/assets/golic.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SponsorBox",
  props: [
    "sponsor_title",
    "logo",
    "text",
    "sponsor_link",
    "blank",
    "showAvatar",
  ],
};
</script>

<style lang="scss">
.sponsor-box {
  &__text {
    line-height: 63px;
    margin: 0 auto;
    font-weight: 700;
  }

  .avatar {
    margin-top: 50px;
  }

  .dot-block {
    bottom: 0;
    right: 0;
    opacity: 0.45;
    width: 50%;
    height: 100%;
  }

  @media screen and (min-width: 768px) {
    &__text {
      font-size: 42px;
      font-style: italic;
      text-align: center;
      max-width: 660px;
      max-height: 441px;
    }
  }
}

.sponsor-box.text-on-primary {
  .sponsor-box__text {
    a,
    a:visited {
      color: var(--color-text-on-primary);
    }
  }
}

.sponsor-box.text-on-light {
  .sponsor-box__text {
    a,
    a:visited {
      color: var(--color-text-on-light);
    }
  }
}
</style>
